import { useEffect, useRef } from 'react';

/**
 * Tracks the current audio element in a ref for cleanup purposes
 */
export function useAudioRef(audioElement: HTMLAudioElement | null) {
	const audioRef = useRef<HTMLAudioElement | null>(null);

	useEffect(() => {
		audioRef.current = audioElement;
	}, [audioElement]);

	return audioRef;
}
